import {
  type AriaProgressBarProps as ArchingProgressBarProps,
  useProgressBar,
} from 'react-aria';
import styles from './ArchingProgressBar.module.css';

export function ArchingProgressBar(props: ArchingProgressBarProps) {
  const { progressBarProps } = useProgressBar(props);

  const { strokeDasharray, strokeDashoffset } = getStrokeValues(props);

  return (
    <svg {...progressBarProps} className={styles['progress-bar-container']}>
      <circle
        className={styles['progress-bar-track']}
        cx="52px"
        cy="52px"
        r="44px"
      />
      <circle
        className={styles['progress-bar']}
        cx="52px"
        cy="52px"
        r="44px"
        style={{ strokeDasharray, strokeDashoffset }}
      />
    </svg>
  );
}

// `44` comes from the radius of the circle.
const arcLength = 2 * Math.PI * 44;

function getStrokeValues({
  value = 0,
  maxValue = 100,
}: {
  value?: number;
  maxValue?: number;
}) {
  const percent = (value / maxValue) * 100;

  let percentAdjusted;

  // Modify the percent so it's never fully 0 and if it is close to 100
  // but not quite, it will be adjusted to 90 to create a clearer visual
  // representation of incompleteness.
  if (percent <= 4) {
    percentAdjusted = 4;
  } else if (percent >= 100) {
    percentAdjusted = 100;
  } else if (percent < 100 && percent > 90) {
    percentAdjusted = 90;
  } else {
    percentAdjusted = percent;
  }

  const arcOffset = arcLength * (1 - percentAdjusted / 2 / 100);

  return {
    strokeDasharray: `${arcLength}px`,
    strokeDashoffset: `${arcOffset}px`,
  };
}
